/* @flow */
import * as React from 'react';

const AdditionalFee = props => (
  <svg
    width={56}
    height={56}
    viewBox="0 0 56 56"
    stroke="none"
    strokeWidth={1}
    fillRule="evenodd"
    {...props}>
    <circle fill="#677BC5" cx={28} cy={28} r={28} />
    <path
      fill="#FFFFFF"
      d="M29.827,39.998 L29.827,37.648 C33.121,37.147 35,34.692 35,32.078 C35,29.464 33.276,27.352 29.853,26.534 L27.331,25.953 C25.813,25.61 25.221,24.844 25.221,23.815 C25.221,22.653 26.147,21.438 28.232,21.438 C30.574,21.438 31.397,23.075 31.603,24.237 L34.794,23.234 C34.382,21.306 33.018,19.089 29.827,18.455 L29.827,16 L26.971,16 L26.971,18.376 C23.985,18.798 21.695,21.122 21.695,24.079 C21.695,26.851 23.548,28.725 26.559,29.438 L29.261,30.045 C30.779,30.362 31.474,31.233 31.474,32.263 C31.474,33.609 30.265,34.56 28.386,34.56 C25.684,34.56 24.449,33.002 24.243,30.969 L21,31.84 C21.206,34.296 23.085,37.147 26.971,37.701 L26.971,39.998 L29.827,39.998 Z"
    />
  </svg>
);

export default AdditionalFee;



// WEBPACK FOOTER //
// ./src/assets/images/icons/additional-fee.js